(function () {
  const FIELD_IMEI = "17536882647567";
  const FIELD_DEVICE_TYPE = "17640607246095";
  const FIELD_PRODUCT_MODEL = "17536868544655";

  const ZENDESK_WAIT_INTERVAL_MS = 250;
  const ZENDESK_WAIT_MAX_ATTEMPTS = 80;
  const APP_DATA_GRACE_MS = 3000;

  /*
   * Device Type -> Product Model
   * Tag must exactly match the Zendesk Product Model Dropdown tag.
   */
  const DEVICE_TYPE_MAP = {
    "2":  { model: "L09", tag: "l09" },
    "4":  { model: "L36E", tag: "l36e" },
    "5":  { model: "L36G_A", tag: "l36g_a" },
    "6":  { model: "S1", tag: "s1" },
    "7":  { model: "L16D", tag: "l16d" },
    "8":  { model: "L36D", tag: "l36d" },
    "9":  { model: "S2", tag: "s2" },
    "10": { model: "L35G", tag: "l35g" },
    "11": { model: "S35G/L29E", tag: "s35g/l29e" },
    "13": { model: "A1", tag: "a1" },
    "14": { model: "A2", tag: "a2" },
    "15": { model: "L16W", tag: "l16w" },
    "16": { model: "L16W", tag: "l16w" },
    "17": { model: "L48E", tag: "l48e" },
    "18": { model: "S16WC", tag: "s16wc" },
    "19": { model: "L12T", tag: "l12t" },
    "20": { model: "L16T", tag: "l16t" },
    "21": { model: "S16W", tag: "s16w" },
    "22": { model: "L09W", tag: "l09w" },
    "24": { model: "S01_24", tag: "s01_24" },
    "25": { model: "25", tag: "25" },
    "26": { model: "26", tag: "26" },
    "27": { model: "L36W", tag: "l36w" },
    "28": { model: "L35E", tag: "l35e" },
    "29": { model: "L36E_B", tag: "l36e_b" },
    "30": { model: "L36D_D", tag: "l36d_d" },
    "31": { model: "S41E", tag: "s41e" },
    "34": { model: "K5", tag: "k5" },
    "35": { model: "K9", tag: "k9" },
    "36": { model: "K3", tag: "k3" },
    "37": { model: "K10", tag: "k10" },
    "38": { model: "A01_eSIM", tag: "a01_esim" },
    "41": { model: "L53Q", tag: "l53q" },
    "47": { model: "L46M_QL", tag: "l46m_ql" },
    "55": { model: "L57Q", tag: "l57q" },
    "59": { model: "K10_Niocall", tag: "k10_niocall" },
    "62": { model: "E26Q", tag: "e26q" },
    "91": { model: "S3", tag: "s3" },
    "92": { model: "NEW", tag: "new" }
  };

  const status = {
    data_received: false,
    zendesk_widget_available: false,
    zendesk_fields_ready: false,
    launcher_clicked: false,
    widget_opened: false,
    last_data: null,
    last_fields: null,
    warning: null,
    error: null
  };

  let currentRequestId = 0;
  let pendingFields = null;
  let fieldsWriteStartedForRequestId = 0;
  let zendeskWaitStarted = false;
  let dataGraceTimer = null;
  let zendeskEventsBound = false;

  function getLauncher() {
    return document.getElementById("lagenio-support-launcher");
  }

  function setLauncherState(state, text) {
    const launcher = getLauncher();
    if (!launcher) return;

    launcher.dataset.state = state;
    launcher.disabled = state === "opening";

    const label = launcher.querySelector("[data-lagenio-support-label]");
    if (label && text) label.textContent = text;
  }

  function hideLauncher() {
    const launcher = getLauncher();
    if (launcher) launcher.hidden = true;
  }

  function showLauncher() {
    const launcher = getLauncher();
    if (!launcher) return;

    launcher.hidden = false;
    setLauncherState("idle", "Contact support");
  }

  function bindZendeskEvents() {
    if (zendeskEventsBound || typeof window.zE !== "function") return;

    zendeskEventsBound = true;

    window.zE("messenger:on", "open", function () {
      status.widget_opened = true;
      hideLauncher();
    });

    window.zE("messenger:on", "close", function () {
      status.widget_opened = false;
      status.launcher_clicked = false;
      showLauncher();
    });
  }

  function resetDataStatus() {
    status.data_received = false;
    status.zendesk_fields_ready = false;
    status.last_data = null;
    status.last_fields = null;
    status.warning = null;
    status.error = null;
    pendingFields = null;
    fieldsWriteStartedForRequestId = 0;
  }

  function openZendesk() {
    if (!status.launcher_clicked || status.widget_opened) return;

    try {
      window.zE("messenger", "open");
      status.widget_opened = true;
      hideLauncher();
    } catch (error) {
      status.error = "zendesk_open_failed";
      setLauncherState("error", "Retry");
      console.error("LAGENIO: Failed to open Zendesk Widget.", error);
    }
  }

  function writeFieldsThenOpen() {
    if (!pendingFields || !status.data_received) return;
    if (status.zendesk_fields_ready) {
      openZendesk();
      return;
    }
    if (fieldsWriteStartedForRequestId === currentRequestId) return;

    const requestId = currentRequestId;
    const fields = pendingFields;
    fieldsWriteStartedForRequestId = requestId;

    try {
      window.zE(
        "messenger:set",
        "conversationFields",
        fields,
        function () {
          if (requestId !== currentRequestId) return;

          status.zendesk_fields_ready = true;
          console.log("LAGENIO: Zendesk conversation fields set.", fields);
          openZendesk();
        }
      );
    } catch (error) {
      fieldsWriteStartedForRequestId = 0;
      status.error = "zendesk_set_failed";
      setLauncherState("error", "Retry");
      console.error("LAGENIO: Failed to set Zendesk conversation fields.", error);
    }
  }

  function continueOpening() {
    if (!status.launcher_clicked) return;
    if (typeof window.zE !== "function") return;

    status.zendesk_widget_available = true;
    bindZendeskEvents();

    if (status.data_received && pendingFields) {
      writeFieldsThenOpen();
      return;
    }

    if (status.warning === "app_data_not_received_before_open") {
      openZendesk();
      return;
    }

    setLauncherState("opening", "Connecting…");

    if (!dataGraceTimer) {
      dataGraceTimer = setTimeout(function () {
        dataGraceTimer = null;

        if (!pendingFields) {
          status.warning = "app_data_not_received_before_open";
          openZendesk();
        }
      }, APP_DATA_GRACE_MS);
    }
  }

  function waitForZendesk(attempt) {
    if (!status.launcher_clicked) {
      zendeskWaitStarted = false;
      return;
    }

    if (typeof window.zE === "function") {
      zendeskWaitStarted = false;
      continueOpening();
      return;
    }

    if (attempt >= ZENDESK_WAIT_MAX_ATTEMPTS) {
      zendeskWaitStarted = false;
      status.error = "zendesk_widget_unavailable";
      setLauncherState("error", "Retry");
      console.error("LAGENIO: Zendesk Widget unavailable.");
      return;
    }

    setTimeout(function () {
      waitForZendesk(attempt + 1);
    }, ZENDESK_WAIT_INTERVAL_MS);
  }

  function requestOpen() {
    status.launcher_clicked = true;
    status.widget_opened = false;
    status.error = null;
    setLauncherState("opening", "Connecting…");

    if (!zendeskWaitStarted) {
      zendeskWaitStarted = true;
      waitForZendesk(0);
    }
  }

  function bindLauncher() {
    const launcher = getLauncher();
    if (!launcher || launcher.dataset.bound === "true") return;

    launcher.dataset.bound = "true";
    launcher.addEventListener("click", requestOpen);
  }

  window.receiveLagenioSupportData = function (input) {
    const requestId = ++currentRequestId;
    resetDataStatus();

    let data = input;

    if (typeof data === "string") {
      try {
        data = JSON.parse(data);
      } catch (error) {
        status.error = "invalid_json";
        console.error("LAGENIO: Invalid JSON.", error);
        return false;
      }
    }

    if (!data || typeof data !== "object" || Array.isArray(data)) {
      status.error = "invalid_app_data";
      console.error("LAGENIO: Invalid APP data.");
      return false;
    }

    const imei = String(data.imei == null ? "" : data.imei).trim();
    const email = String(data.email == null ? "" : data.email).trim();
    const deviceType = String(
      data.device_type == null ? "" : data.device_type
    ).trim();

    status.data_received = true;

    const mapping = DEVICE_TYPE_MAP[deviceType] || null;

    status.last_data = {
      imei: imei,
      email: email,
      device_type: deviceType,
      product_model: mapping ? mapping.model : null,
      product_model_tag: mapping ? mapping.tag : null
    };

    console.log("LAGENIO: APP data received.", status.last_data);

    if (!/^\d{15}$/.test(imei)) {
      status.error = "invalid_imei";
      console.error("LAGENIO: Invalid IMEI.", imei);
      return false;
    }

    if (!/^\d+$/.test(deviceType)) {
      status.error = "invalid_device_type";
      console.error("LAGENIO: Invalid Device Type.", deviceType);
      return false;
    }

    const fields = [
      { id: FIELD_IMEI, value: imei },
      { id: FIELD_DEVICE_TYPE, value: deviceType }
    ];

    if (mapping) {
      fields.push({
        id: FIELD_PRODUCT_MODEL,
        value: mapping.tag
      });
    } else {
      status.warning = "unmapped_product_model";
      console.warn(
        "LAGENIO: No Product Model mapping for Device Type.",
        deviceType
      );
    }

    status.last_fields = fields;
    pendingFields = fields;

    if (dataGraceTimer) {
      clearTimeout(dataGraceTimer);
      dataGraceTimer = null;
    }

    if (status.launcher_clicked) {
      continueOpening();
    }

    return true;
  };

  window.getLagenioSupportStatus = function () {
    return JSON.stringify(status);
  };

  bindLauncher();
  window.LAGENIO_SUPPORT_READY = true;
  console.log("LAGENIO: Support receiver ready.");
})();
